import { QuotationConditionEnum } from 'app/_models/_enums/quotationCondition.enum';
import { QuotationPartTypeEnum } from 'app/_models/_enums/quotationPartType.enum';

export interface QuotationPart {
    quantity: number,
    partName: string,
    partNumber?: string,
    quotationPartTypes?: QuotationPartTypeEnum[],
    types?: string[],
    partType?: number,
    allowsUsed?: boolean,
    insurancePrice?: number,
    insuranceDiscount?: number
}

export function quotationPartFactory(partName: string, quantity: number, partNumber: string = null, typesId: QuotationPartTypeEnum[] = null, allowsUsed: boolean = null, insurancePrice: number = null, insuranceDiscount: number = null): QuotationPart {
    var trimedPartNumber = partNumber?.trim();

    return {
        partName: partName.toPascalCase(),
        partNumber: trimedPartNumber ? trimedPartNumber.toUpperCase() : null,
        quantity: quantity,
        quotationPartTypes: typesId,
        types: typesId ? typesId.map(t => QuotationPartTypeEnum[t].toLowerCase()) : null,
        partType: typesId ? typesId.reduce((a, b) => a + b, 0) : null,
        allowsUsed: allowsUsed,
        insurancePrice: insurancePrice,
        insuranceDiscount: insuranceDiscount,
    } as QuotationPart;
}
